"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const featureToggle_1 = require("modules/featureToggle");
const withFeatureToggle = (WrappedComponent, feature) => {
    return (props) => {
        return ((0, jsx_runtime_1.jsx)(mobx_react_1.Observer, { children: () => {
                const isEnabled = featureToggle_1.FeatureToggleService.isEnabled(feature);
                return isEnabled ? (0, jsx_runtime_1.jsx)(WrappedComponent, { ...props }) : null;
            } }));
    };
};
exports.default = withFeatureToggle;
